export const REFUND_MSG = {
  stripe: "Rimborso eseguito su Stripe: il paziente lo riceve sulla carta",
  wallet: "Rimborso riaccreditato in SLVX sulla Selvix Card del paziente",
  non_eseguito_chiave_condivisa: "Rimborso registrato. Su Stripe non è partito: serve la chiave Stripe del tuo account",
  solo_registrato: "Rimborso registrato (pagamento non effettuato con carta Stripe)",
};

import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || JSON.stringify(x)).replace(/^Value error, /, "")).join(" ");
  return d.msg || String(d);
}

export const eur = (n) => `€ ${Number(n || 0).toFixed(2).replace(".", ",")}`;

export const serviceAmount = (s) => (s?.pricing_type === "oraria" ? Math.round(s.price * (s.duration_min || 60) / 60 * 100) / 100 : Number(s?.price || 0));
export const servicePriceLabel = (s) => {
  if (s?.pricing_type === "oraria") return `${eur(s.price)}/ora · ${eur(serviceAmount(s))}`;
  if (s?.pricing_type === "forfettaria") return `${eur(s.price)} forfait`;
  return eur(s?.price);
};

export const STATUS_LABELS = {
  richiesta_inviata: "Richiesta inviata",
  in_attesa_pagamento: "In attesa di pagamento",
  confermato: "Confermato",
  annullato: "Annullato",
  completato: "Completato",
  rifiutato: "Rifiutato",
  inviata: "Inviata",
  in_verifica: "In verifica medica",
  approvata: "Approvata dal medico",
  rifiutata: "Rifiutata",
  in_attesa: "In attesa",
  pagato: "Pagato",
  rimborsato: "Rimborsato",
  rimborsato_parziale: "Rimborso parziale",
  non_pagato: "Non pagato",
  rimborso_richiesto: "Rimborso richiesto",
};

export const STATUS_TONE = {
  confermato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  approvata: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pagato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completato: "bg-slate-100 text-slate-700 border-slate-200",
  annullato: "bg-rose-50 text-rose-700 border-rose-200",
  rifiutato: "bg-rose-50 text-rose-700 border-rose-200",
  rifiutata: "bg-rose-50 text-rose-700 border-rose-200",
  rimborsato: "bg-slate-100 text-slate-700 border-slate-200",
};

export const KIND_LABELS = { video: "Video consulto", domicilio: "Domicilio", visita: "Visita ambulatoriale" };
export const TIME_BANDS = { mattina: "Mattina (08–12)", pomeriggio: "Pomeriggio (13–17)", sera: "Sera (17–20)" };
export const STAFF_ROLES = ["medico", "infermiere", "segreteria", "admin", "super_admin"];
export const ADMIN_ROLES = ["admin", "super_admin"];
export const ROLE_LABELS = {
  paziente: "Paziente", medico: "Medico", infermiere: "Infermiere / Professionista",
  segreteria: "Segreteria", admin: "Amministratore", super_admin: "Super Admin",
};

export const fmtDate = (s) => {
  if (!s) return "";
  const d = new Date(s.length === 10 ? `${s}T00:00:00` : s);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");
export const todayStr = () => new Date().toISOString().slice(0, 10);
